'use client';

import LabelBadge from '@/shared/components/LabelBadge';
import { CONTACT_LIST_TYPE_DISPLAY, ContactListType } from '../types';

interface ContactListTypeTagProps {
  type: ContactListType;
}

const ContactListTypeTag = ({ type }: ContactListTypeTagProps) => {
  const getTagColor = (type: ContactListType) => {
    switch (type) {
      case 'p2p-sms':
        return 'blue';
      case 'suppression':
        return 'yellow';
      case 'test':
        return 'purple';
      default:
        return 'gray';
    }
  };

  return (
    <LabelBadge color={getTagColor(type)}>{CONTACT_LIST_TYPE_DISPLAY[type]}</LabelBadge>
  );
};

export default ContactListTypeTag;
